export var GREENHOUSE_API_BASE_URL = "https://boards-api.greenhouse.io";
